import { render, staticRenderFns } from "./importbprs.vue?vue&type=template&id=34ffe4bf"
import script from "./importbprs.vue?vue&type=script&lang=js"
export * from "./importbprs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports